// extracted by mini-css-extract-plugin
export var cmtPointer = "styles-module--cmt-pointer--fba93";
export var cmtPointerShow = "styles-module--cmt-pointer--show--a7d46";
export var cmtPointer__text = "styles-module--cmt-pointer__text--31e0e";